import { render } from "./AiReportStatusChip.vue?vue&type=template&id=58b17a32&ts=true"
import script from "./AiReportStatusChip.vue?vue&type=script&lang=ts"
export * from "./AiReportStatusChip.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__